import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Credentials } from 'share/domain/authentication'

const initialState: Credentials = {
  userName: null,
  password: null,
  mobilePhone: null
}

export function getEmptyCredentials(): Credentials {
  const creds: Credentials = {
    userName: null,
    password: null,
    mobilePhone: null
  }

  return creds
}

const credentials = createSlice({
  name: 'credentials',
  initialState: initialState,
  reducers: {
    setCredentials(state, { payload }: PayloadAction<Credentials>) {
      return payload
    }
  }
})

export const { setCredentials } = credentials.actions

export default credentials.reducer
